import { Button, Flex, Form, Input, Select, Row, Col } from "antd";
import { useEffect } from "react";

const ComportConfigurationForm = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.editData) {
      form.setFieldsValue(props.editData);
    } else {
      form.resetFields();
    }
  }, [props.editData, form]);

  const handleFinish = (data) => {
    return props.saveData(data).then((success) => {
      if (success) {
        form.resetFields();
      }
    });
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Port"
            name="port"
            rules={[{ required: true, message: "Please input port!" }]}
          >
            <Input placeholder="Ex: COM3" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Baud Rate"
            name="baudRate"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select baud rate"
              options={[
                1200, 2400, 4800, 9600, 14400, 19200, 28800, 38400, 57600,
                115200, 230400,
              ].map((e) => ({ label: e, value: e }))}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="Data Bits"
            name="dataBits"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select data bits"
              options={[5, 6, 7, 8].map((e) => ({
                label: e,
                value: e,
              }))}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="Stop Bits"
            name="stopBits"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select stop bits"
              options={[1, 2].map((e) => ({
                label: e,
                value: e,
              }))}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="Parity" name="parity" rules={[{ required: true }]}>
            <Select
              placeholder="Select parity"
              options={["NONE", "EVEN", "ODD", "MARK", "SPACE"].map((e) => ({
                label: e,
                value: e,
              }))}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="Flow Control"
            name="flowControl"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select flow control"
              options={["NONE", "RTS/CTS", "DTR/DSR", "XON/XOFF"].map((e) => ({
                label: e,
                value: e,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* ================= ACTION ================= */}
      <Flex justify="end">
        <Button type="primary" size="large" htmlType="submit">
          {props.editData ? "Update " : "Save "}Configuration
        </Button>
      </Flex>
    </Form>
  );
};

export default ComportConfigurationForm;
